import React from 'react';
import { trackInitiateCheckout } from '../lib/pixel';
export function StickyMobileCTA() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-zinc-950/90 backdrop-blur-lg border-t border-zinc-800 z-50" data-id="element-239">
      <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" onClick={trackInitiateCheckout} className="flex items-center justify-center w-full py-3.5 px-4 text-sm font-bold text-white bg-blue-600 rounded-xl shadow-[0_0_15px_rgba(37,99,235,0.3)] active:scale-95 transition-transform" data-id="element-240">
        Comprar guía — $14.900 ARS
      </a>
    </div>;
}